export default __webpack_public_path__ + "static/media/a011-example3.2399da0b.jpg";